import Header from "@/routes/_layout/header"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import useIsMobile from "@/hooks/use-is-mobile"
import AptLayout from "@/routes/apt/apt-layout"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import AptNavs from "../_layout/nav/apt-navs"

const AptPages = () => {
  const isMobile = useIsMobile()
  const mode = isMobile ? "mobile" : "desktop"

  const location = useLocation()

  // const { pickApt } = aptSearchStore()

  const section = location.pathname.split("/").at(4)
  // INFO : 섹션마다 헤더 선택
  const HeaderComponent = Header[section][mode] ?? Header.default

  useEffect(() => {
    return () => {
      aptSearchStore.getState().pickReset()
    }
  }, [])

  // if (!pickApt) return null

  return <AptLayout header={<HeaderComponent />} navs={<AptNavs />} />
}

export default AptPages
